import styled from 'styled-components';
import {
  formatDateShort,
  formatDateMedium,
  formatDateTimeShort,
  parseDate,
} from '@ardoq/date-time';
import { DecoratorPlaceholder, DecoratorWrapper } from '@ardoq/decorators';
import { Icon, IconName } from '@ardoq/icons';
import { type Locale } from '@ardoq/locale';
import { type I18nLocale, t } from '@ardoq/i18n';

type IntegrationDateProps = {
  date?: string | null;
  placeholder?: string;
  showIcon?: boolean;
  format?: 'DATE' | 'DATETIME' | 'DATENEW';
  locale: Locale;
  i18nLocale: I18nLocale;
};

const DateContainer = styled(DecoratorWrapper)`
  white-space: nowrap;
`;

export const IntegrationDate = ({
  date,
  showIcon = false,
  placeholder,
  format = 'DATETIME',
  locale,
  i18nLocale,
}: IntegrationDateProps) => {
  const placeholderText =
    placeholder ??
    t(
      i18nLocale,
      'integrations:integrationDate.notYetStarted',
      'Not yet started'
    );
  return date ? (
    <DateContainer data-tooltip-text={parseDate(date).toString()}>
      {showIcon && <Icon iconName={IconName.CALENDAR} />}
      {format === 'DATE'
        ? formatDateShort(date, locale)
        : format === 'DATETIME'
          ? formatDateTimeShort(date, locale)
          : formatDateMedium(date, locale)}
    </DateContainer>
  ) : (
    <DecoratorPlaceholder>{placeholderText}</DecoratorPlaceholder>
  );
};
